module.exports = __webpack_public_path__ + "static/media/plus_black.a558c9bf.svg";